import { useAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { omniAtom } from "src/utils/atoms";

type CdtLevel = "variant" | "cdt1" | "cdt2" | "cdt3";

const newCdtNodeAtom = omniAtom({
  key: "ModalNewCdtNode",
  value: null as null | { cdtLevel: CdtLevel; value: null | string },
});

export const useNewCdtNodeModal = () => {
  const { openModal, closeModal } = useModals();
  const [newCdtNodeData, setNewCdtNodeData] = useAtom(newCdtNodeAtom);

  const openNewCdtNodeModal = (cdtLevel: CdtLevel) => {
    setNewCdtNodeData({ cdtLevel, value: null });
    openModal("ModalNewCdtNode");
  };

  const setNewCdtNodeValue = (cdtLevel: CdtLevel, value: string) => {
    setNewCdtNodeData({ cdtLevel, value });
    closeModal("ModalNewCdtNode");
  };

  return { openNewCdtNodeModal, setNewCdtNodeValue, newCdtNodeData };
};
